export default "__VITE_ASSET__DaobQHrt__"